<template>
  <v-container fluid>
    <v-row>
      <v-col
        md="9"
        style="
          width: 100vw;
          height: 100vh;
          background-position-x: 10%;
          background-position-y: 20%;
          background-repeat: no-repeat;
          background-attachment: fixed;
        "
        :style="{ backgroundImage: 'url(' + image + ')' }"
      >
        <div
          v-for="(item, index) in items"
          :key="index"
        >
          <div v-draggable="item.dragg">
            <img  
              :src="item.src"
              
               
              height="30"
            ><span style="backgroundColor:#f3f4f7 ; max-width: 140px ; font-size:16px;font-weight:bold">{{ item.text }}</span>
          </div>
        </div>
      </v-col>

      <v-col
        md="3"
        style="height: calc(100vh - 200px); overflow-y: auto"
      >
        <base64-upload
          image-src="upload.png"
          :image-style="{ 'border-radius': '50%', width: '50px' }"
          @change="onChangeImage"
        >
          Upload
        </base64-upload>

        <!-- <v-btn @click="addBtn" outlined>Add</v-btn> -->
        <v-col cols="12">
          <v-select
            v-model="fieldListValue"
            :items="fieldList"
            label="選擇場域"
            solo
            @input="fieldChangeAna"
          />
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="didListValue"
            :items="didList"
            label="設備編號"
            solo
            @input="didChange"
          />
        </v-col>
        <v-checkbox
          v-for="(item, index) in fieldSensorList"
          :key="index"
          v-model="item.value"
          class="checkboxVert"
          :label="`${item.val_name.toString()}`"
          @change="checkSensorBtn(item, index)"
        />
      </v-col>
    </v-row>
    <v-progress-linear
      v-show="showloading"
      indeterminate
      color="green"
    />
  </v-container>
</template>

<script>
import Vue from "vue";
import Base64Upload from "vue-base64-upload";
import { Draggable } from "draggable-vue-directive";
import Cookies from "js-cookie";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(Loading);

export default {
  directives: {
    Draggable,
  },
  components: {
    Base64Upload,
  },
  data() {
    return {
      showloading: false,
      draggableValuearray: [],
      draggableValue: {
        onDragEnd: this.onPosChanged,
        initialPosition: { left: 345, top: 511 },
        resetInitialPos: false,
      },
      image: "demobg.jpg",
      files: [],
      items: [],
      initobj: {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        src: "device.png",
        id: "",
      },
      fieldList: [],
      fieldListValue: "測試用",
      deviceList: ["01"],
      fieldSensorList: [],
      fieldSensorValue: "",
      didListValue: "01",
      didList: [],
      filterDevice: {},
    };
  },
  computed: {
    host() {
      return this.$store.state.host;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    loginUID() {
      return this.$store.state.loginUID;
    },
    exec_cust_gateway_000() {
      return this.$store.state.exec_cust_gateway_000;
    },
  },
  mounted: function () {
    Cookies.set("url", "/MapEdit");

    this.items = [];
    // this.items.push(this.initobj);
    // this.items.push(this.initobj);

    let nform = {
      cust_id: this.loginInfo.cust_id,
    };
    this.fieldList = [];
    this.$store
      .dispatch("exec_cust_gateway_000", nform)
      .then((res) => {
        if (this.loginUID.superuser == "0") {
          nform = {
            cust_id: this.loginInfo.cust_id,
            uid: this.loginInfo.uid,
          };

          this.$store
            .dispatch("exec_uid_gateway_000", nform)
            .then((res) => {
              res = res.trim();
              if (res != null && res.length > 0) {
                for (var i = 0; i < res.length; i++) {
                  let gw_no = res[i].gw_no;

                  for (var j = 0; j < this.exec_cust_gateway_000.length; j++) {
                    let item = this.exec_cust_gateway_000[j];

                    if (gw_no == item.ip_adrs) {
                      this.fieldList.push(item.gw_desc);
                    }
                  }
                }

                if (this.fieldList != null && this.fieldList.length > 0) {
                  this.fieldListValue = this.fieldList[0];
                }
                this.fieldChangeAna(this.fieldListValue);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.fieldList = this.exec_cust_gateway_000.map(function (item) {
            return item.gw_desc;
          });

          if (this.fieldList != null && this.fieldList.length > 0) {
            this.fieldListValue = this.fieldList[0];
          }

          this.fieldChangeAna(this.fieldListValue);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {

    onPosChanged: function (positionDiff, absolutePosition, event) {
      //const path = event.path || (event.composedPath && event.composedPath())
       console.log(event);
      //let text = event.path[1].textContent.trim();     
      //let idx = text.indexOf("(");
      //let val_name = text.substring(0, idx);
      
      console.log(event.toElement.innerHTML);
      let text = event.toElement.innerHTML;     
      let idx = text.indexOf("(");
      let val_name = text.substring(0, idx);
      //let obj_x = event.clientX;
      //let obj_y = event.clientY;
    
      let items = this.fieldSensorList.filter(function (obj) {
        return obj.c_val_name === val_name;
      });

      if (items == null || items.length == 0) {
        return;
      }

      let nform = {
        cond: this.filterDevice[0].ip_adrs,
        did: this.didListValue,
        val_name: items[0].t_val_name,
        obj_x: absolutePosition.left,
        obj_y: absolutePosition.top,
      };

      this.$store
        .dispatch("exec_device_now_v2_id_001", nform)
        .then((res) => {
           console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
    checkSensorBtn(row, index) {
      if (row.value) {
        let obj = Object.assign({}, this.initobj);
        let dragg = Object.assign({}, this.draggableValue);
        obj.id = row.val;
        obj.text = row.c_val_name + "(" + row.val + ")";
        if (row.obj_x == 0) {
          row.obj_x = 300;
        }
        obj.c_val_name = row.c_val_name;

        if (row.obj_y == 0) {
          row.obj_y = 300;
        }

        dragg.initialPosition = {
          left: Number(row.obj_x),
          top: Number(row.obj_y),
        };
        dragg.resetInitialPos = false;
        obj.dragg = dragg;

        if (row.src != "") {
          obj.src = row.src;
        }

        this.items.push(obj);
      } else {
        this.items = this.items.filter(function (obj) {
          return obj.id !== row.val;
        });

        console.log(row);


      let nform = {
        cond: this.filterDevice[0].ip_adrs,
        did: this.didListValue,
        val_name: row.t_val_name,
        obj_x: 0,
        obj_y: 0,
      };

      this.$store
        .dispatch("exec_device_now_v2_id_001", nform)
        .then((res) => {
           console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
      }
    },
    addBtn() {
      this.items.push(this.initobj);
    },
    onChangeImage(file) {
      this.image = "data:" + file.type + ";base64," + file.base64;
      let nform = {
        ip_adrs: this.filterDevice[0].ip_adrs,
        base64_image_content: this.image,
      };
      this.showloading = true;
      nform = JSON.stringify(nform);
      this.$store
        .dispatch("ig_pic_001", nform)
        .then((res) => {
          this.showloading = false;
          if (res == "done") {
          } else {
            alert("update load fail");
            return;
          }
          nform = {
            ip_adrs: this.filterDevice[0].ip_adrs,
          };

          this.$store
            .dispatch("exec_cust_gateway_001", nform)
            .then((res) => {
              if (res != null && res.length > 0) {
                let img = res[0].layout_pic;
                this.image = this.host + "/images/" + img;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    fieldChangeAna(val) {
      if (
        this.exec_cust_gateway_000 != null &&
        this.exec_cust_gateway_000.length > 0
      ) {
        this.filterDevice = this.exec_cust_gateway_000.filter(function (
          item,
          index,
          array
        ) {
          return item.gw_desc == val;
        });
        this.items = [];
        if (this.filterDevice != null && this.filterDevice.length > 0) {
          this.didChange("01");
          let nform = {
            cond: this.filterDevice[0].ip_adrs,
          };
          this.$store
            .dispatch("exec_equip_valname_000", nform)
            .then((res) => {
              if (res != null && res.length > 0) {
                this.didList = res.map(function (item) {
                  return item.did;
                });
                this.didList = this.didList.filter(this.onlyUnique);
              }
            })
            .catch((err) => {
              console.log(err);
            });

          nform = {
            ip_adrs: this.filterDevice[0].ip_adrs,
          };

          this.$store
            .dispatch("exec_cust_gateway_001", nform)
            .then((res) => {
              // console.log(res);

              if (res != null && res.length > 0) {
                let img = res[0].layout_pic;
                this.image = this.host + "/images/" + img;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    didChange(val) {
      let vall = val + " ";
      this.items = [];
      let nform = {
        cond: this.filterDevice[0].ip_adrs,
        did: vall,
      };
      let that = this;
      this.fieldSensorList = [];
      this.$store
        .dispatch("exec_device_now_v2_000", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            this.fieldSensorList = res.map(function (item) {
              // console.log(item)
              let value = false;
              if (item.obj_x != 0 && item.obj_y != 0) {
                value = true;
              }

              item.val_icon = that.host + "/php/" + item.val_icon;

              let obj = {
                val_name: item.c_val_name + "(" + item.val_name + ")",
                key: item.ip_adrs + " " + item.dat,
                value: value,
                t_val_name: item.val_name,
                val: item.c_val_name,
                obj_x: item.obj_x,
                obj_y: item.obj_y,
                c_val_name: item.c_val_name,
                val: item.value,
                src: item.val_icon,
              };

              if (item.obj_x != 0 && item.obj_y != 0) {
                that.checkSensorBtn(obj, 1);
              }

              return obj;
            });

            this.removeDuplicates(this.fieldSensorList, "key");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
  },
};
</script>

<style>
.checkboxVert {
  width: 100% !important;
}
</style>